import { useState } from 'react';
import { DotsVertical } from 'mdi-material-ui';
import { Menu } from '../Menu';
import { IconButton, IconButtonProps } from '../IconButton';
import { useContainerContext } from './ContainerContextProvider';

export interface ContainerMenuProps {
  children: React.ReactNode;
  size?: IconButtonProps['size'];
}

export const ContainerMenu = ({ children, size }: ContainerMenuProps) => {
  const { setIsMenuOpen } = useContainerContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
    setIsMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(false);
    setIsMenuOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleClick} aria-label="See more actions" size={size}>
        <DotsVertical />
      </IconButton>
      <Menu open={isOpen} anchorEl={anchorEl} onClose={handleClose} onClick={handleClose}>
        {children}
      </Menu>
    </>
  );
};
